module.exports = __webpack_public_path__ + "static/media/external-link-square-alt.a64be77a.svg";